'use strict'

/**
 * Optimized Scroll Event
 *
 * - handle event
 * - window.addEventListener('optimizedScroll')
 */

const throttle = (type, name, obj = window) => {
  let running = false
  const func = () => {
    if (running) {
      return
    }
    running = true
    window.requestAnimationFrame(() => {
      if (document.createEventObject) {
        obj.fireEvent(name)
      } else {
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent(name, false, true)
        obj.dispatchEvent(evt)
      }
      running = false
    })
  }
  obj.addEventListener(type, func)
}

throttle('scroll', 'optimizedScroll')
